<template>
    <div>
        <time-care-form :id="id"></time-care-form>
    </div>
</template>

<script>
import TimeCareForm from '@app/pages/users/partials/TimeCareForm';

export default {
    components: {
        TimeCareForm,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
};

</script>
